import keyMirror from 'keymirror';
import _cloneDeep from 'lodash/cloneDeep';
import _findIndex from 'lodash/findIndex';

export const createListActionTypes = keyMirror({
	LIST_OPTIONS_REQUEST: null,
	LIST_OPTIONS_SUCCESS: null,
	LIST_OPTIONS_ERROR: null,

	WORD_SUGGESTION_REQUEST: null,
	WORD_SUGGESTION_SUCCESS: null,
	WORD_SUGGESTION_ERROR: null,

	CREATE_LIST_REQUEST: null,
	CREATE_LIST_SUCCESS: null,
	CREATE_LIST_ERROR: null,

	DELETE_DRAFT_LIST_REQUEST: null,
	DELETE_DRAFT_LIST_SUCCESS: null,
	DELETE_DRAFT_LIST_ERROR: null,

	EDIT_LIST_DATA_REQUEST: null,
	EDIT_LIST_DATA_SUCCESS: null,
	EDIT_LIST_DATA_ERROR: null,

	SET_ADD_IMAGE_MODAL: null,
	SET_IMAGE_OVERVIEW_MODAL: null,

	CLEAN_LIST_STATE: null,
	DELETE_UPLOADED_IMAGE: null,

	TOGGLE_IMPORT_MODAL: null,
	CLOSE_LIST_PAGE: null,
	SET_LIST_WORDS: null,
	SET_NEW_CREATED_CHAPTER: null,
	SET_CREATE_LIST_PRESELECTED_OPTIONS: null,
});

export const MAX_LIST_NAME_LENGTH = 70;

export const splitByLine = (value) => value.replace(/\r\n/g, '\r').replace(/\n/g, '\r').split(/\r/);

export const getWords = (selectedRadioName, rows) => {
	const symbol = selectedRadioName === '1' ? '\t' : ' = ';

	return rows.map((item) => ({ words: item.split(symbol).slice(0, 2) }));
};

export const placeholderWithTab =
	'Voorbeeld \n\n Woord    betekenis\n Woord    betekenis\n Woord    betekenis';

export const placeholderWithEqual =
	'Voorbeeld \n\n Woord = betekenis\n Woord = betekenis\n Woord = betekenis';

export const concatSuggestions = (suggestions, item) => {
	const suggestionsArr = [...suggestions];
	const i = _findIndex(
		suggestionsArr,
		(suggestionItem) => suggestionItem.id === item.id && suggestionItem.column === item.column,
	);

	if (i > -1) {
		suggestionsArr[i] = { ...suggestionsArr[i], ...item };
	} else {
		suggestionsArr.push(item);
	}

	return suggestionsArr;
};

export const getFallbackOption = (options) => options && options.filter((item) => item.fallback)[0];

export const fixEncoding = (str) => {
	const misencodedPattern = /[Ã¤Ã¶Ã¼Ã]/;

	if (misencodedPattern.test(str)) {
		try {
			const bytes = new Uint8Array(str.split('').map((char) => char.charCodeAt(0)));
			const decodedString = new TextDecoder('utf-8').decode(bytes);

			if (!misencodedPattern.test(decodedString)) {
				return decodedString;
			}
		} catch (e) {
			console.error('Decoding error:', e);
		}
	}

	return str;
};
